import { Collapse, Flex, Text } from '@chakra-ui/react'
import * as React from 'react'
import { useEffect, useState } from 'react'

export const CollapseError: React.FC<{
  error?: string | null
  style?: React.CSSProperties
  inverted?: boolean
  textAlign?: 'center' | 'left' | 'right'
}> = ({ error, style, inverted = false, textAlign: textAlignProp }) => {
  const [prevError, setPrevError] = useState<string | null>(null)
  useEffect(() => {
    if (error) setPrevError(error)
  }, [error])

  const textAlign = textAlignProp ?? (inverted ? 'left' : 'center')

  return (
    <Collapse style={{ width: '100%' }} in={!!error}>
      <Flex
        width="100%"
        bg={inverted ? 'transparent' : 'red.500'}
        fontSize="sm"
        py={2}
        px={1}
        style={style}>
        <Text
          fontWeight={inverted ? 600 : 500}
          textAlign={textAlign}
          w="100%"
          fontFamily="Open Sans"
          lineHeight={1.1}
          color={inverted ? 'red.500' : 'white'}>
          {prevError}
        </Text>
      </Flex>
    </Collapse>
  )
}
